import { readOnly } from '@yola/ws-sdk';
import { SELECT } from 'src/js/modules/custom-tools/constants/trigger-types';
import selectors from '../../../common/constants/selectors';
import StretchToolContainer from '../containers/stretch-tool-container';

const stretchToolSettings = {
  triggerOn: SELECT,
  matches(element) {
    if (readOnly.verifiers.isReadOnlyModeEnabled()) {
      return false;
    }

    return element.matches(selectors.COMPOSITE_ITEM);
  },
  container: StretchToolContainer,
};

export default stretchToolSettings;
